import { Star, Quote } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { SITE } from "@/lib/site";

const testimonials = [
  {
    name: "Aisyah R.",
    location: "Shah Alam",
    text: "Encik Firdaus sangat membantu dari awal hingga akhir. Permohonan rumah pertama saya diluluskan dengan mudah. Terima kasih!",
  },
  {
    name: "Hafiz M.",
    location: "Kuala Lumpur",
    text: "Proses refinance saya diuruskan dengan profesional. Semua dokumen dijaga rapi dan sulit. Sangat dipercayai.",
  },
  {
    name: "Nurul & Zaki",
    location: "Cyberjaya",
    text: "Kami risau nak hantar dokumen online, tapi beliau jelaskan semuanya. Selamat & senang. Kini kami dah ada rumah sendiri.",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 bg-white">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-center">
          <Reveal className="lg:col-span-1">
            <img
              src={SITE.images.keys}
              alt="Keluarga menerima kunci rumah"
              className="w-full h-[340px] object-cover rounded-3xl border border-slate-200"
              loading="lazy"
            />
          </Reveal>

          <div className="lg:col-span-2">
            <Reveal>
              <span className="text-sm font-semibold uppercase tracking-wider text-[#1D4ED8]">
                Apa Kata Pelanggan
              </span>
              <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A2540]">
                Kisah kejayaan pelanggan saya
              </h2>
            </Reveal>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
              {testimonials.map((t, i) => (
                <Reveal key={t.name} delay={i * 0.1}>
                  <div
                    data-testid={`testimonial-${i + 1}`}
                    className="h-full rounded-2xl border border-slate-200 p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
                  >
                    <Quote className="h-7 w-7 text-[#F59E0B]" />
                    <p className="mt-3 text-slate-700 leading-relaxed text-sm">&ldquo;{t.text}&rdquo;</p>
                    <div className="mt-4 flex items-center gap-1">
                      {[...Array(5)].map((_, s) => (
                        <Star key={s} className="h-4 w-4 fill-[#F59E0B] text-[#F59E0B]" />
                      ))}
                    </div>
                    <p className="mt-3 font-heading font-bold text-[#0A2540]">{t.name}</p>
                    <p className="text-xs text-slate-500">{t.location}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
